import axios from 'axios'

class AboutUsService {
  getAboutUs = () =>
    axios({
      url: 'about-us/admin',
      method: 'GET',
    })

  updateAboutUs = (data) =>
    axios({
      url: 'about-us/admin',
      method: 'PUT',
      data,
    })
}

export default new AboutUsService()

